import(/* webpackMode: "eager" */ "/root/elawphant/src/app/[locale]/companies/page.tsx");
